import { Component, OnDestroy, OnInit } from '@angular/core';
import { InquiryServiceType } from '@webapp/core/enums';
import {
  InquiryFlowStep,
  PublicInquiryManagerService,
} from 'projects/webapp/app/services/public-inquiry-manager.service';
import { Subject, takeUntil } from 'rxjs';

const FLOW_LABELS: Record<InquiryServiceType, string> = {
  [InquiryServiceType.MOVE]: 'Umzug',
  [InquiryServiceType.CLEAN]: 'Reinigung',
  [InquiryServiceType.MOVE_AND_CLEAN]: 'Umzug & Reinigung',
};

/** Half a minute per open step: the welcome screen promises "unter 3 Minuten". */
const MINUTES_PER_STEP = 0.5;

/**
 * Progress and step list beside the form. Steps already done can be clicked
 * to go back to them; later ones cannot — forward only goes through "Weiter",
 * which validates. Below 900 px only the progress card remains.
 */
@Component({
  selector: 'app-inquiry-sidebar',
  templateUrl: './inquiry-sidebar.component.html',
})
export class InquirySidebarComponent implements OnInit, OnDestroy {
  steps: InquiryFlowStep[] = [];
  currentIndex = 0;
  flowLabel = '';

  get percent() {
    return this.steps.length ? Math.round(this.currentIndex / this.steps.length * 100) : 0;
  }

  get minutesLeft() {
    return Math.max(1, Math.ceil((this.steps.length - this.currentIndex) * MINUTES_PER_STEP));
  }

  protected _destroy$ = new Subject<void>();

  constructor(protected _publicInquiryManagerService: PublicInquiryManagerService) {
  }

  ngOnInit(): void {
    this._publicInquiryManagerService.inquiryCreationProgress$
      .pipe(takeUntil(this._destroy$))
      .subscribe(progress => {
        this.steps = this._publicInquiryManagerService.flowSteps(progress?.service);
        this.currentIndex = Math.max(0, this.steps.findIndex(s => s.step === progress?.currentStep));
        this.flowLabel = progress ? FLOW_LABELS[progress.service] ?? '' : '';
      });
  }

  ngOnDestroy() {
    this._destroy$.next();
    this._destroy$.complete();
  }

  goTo(step: InquiryFlowStep) {
    this._publicInquiryManagerService.goToStep(step.step);
  }
}
